"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.lightPalette = exports.proLightPalette = exports.facilityLightPalette = void 0;
const createPalette_1 = __importDefault(require("@mui/material/styles/createPalette"));
const createTheme_1 = __importDefault(require("@mui/material/styles/createTheme"));
const palette_1 = require("./palette");
const defaultMUITheme = (0, createTheme_1.default)();
const sharedPalette = {
    primary: { main: palette_1.palette.primary[400], light: palette_1.palette.primary[50] },
    secondary: defaultMUITheme.palette.augmentColor({
        color: { main: palette_1.palette.secondary[400] },
        name: 'secondary',
    }),
    error: { main: palette_1.palette.error[400], light: palette_1.palette.error[50], backing: "#952A1F0F" },
    info: {
        main: palette_1.palette.info[400],
        light: palette_1.palette.info[50],
    },
    success: {
        main: palette_1.palette.success[400],
        light: palette_1.palette.success[50],
        dark: palette_1.palette.success[800],
    },
    warning: {
        dark: palette_1.palette.warning[800],
        main: palette_1.palette.warning[400],
        light: palette_1.palette.warning[50],
    },
    danger: defaultMUITheme.palette.augmentColor({
        color: { main: palette_1.palette.danger[400] },
        name: 'danger',
    }),
    text: {
        primary: palette_1.palette.text[400],
        secondary: palette_1.palette.text[200],
        disabled: palette_1.palette.text[100],
    },
};
exports.facilityLightPalette = (0, createPalette_1.default)({
    ...sharedPalette,
    background: {
        default: '#F9FAFB',
    },
});
exports.proLightPalette = (0, createPalette_1.default)({
    ...sharedPalette,
});
exports.lightPalette = (0, createPalette_1.default)({
    ...sharedPalette,
});
